// src/pages/Company.jsx
import React from "react";
import ContactForm3 from "../components/ContactForm3";
import Footer from "../components/Footer";

export default function Company() {
  return (
    <>
    <section className="min-h-screen py-20 px-6 sm:px-8 bg-[#1A1631] text-white">
      <div className="max-w-5xl mx-auto">
        {/* Back Link */}
        <a
          href="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          <span className="mr-2 text-lg">←</span> Back to main site
        </a>

        {/* Page Title */}
        <h1 className="text-4xl md:text-5xl font-bold mb-8">
          <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            About Apoello
          </span>
        </h1>

        {/* Intro Paragraph */}
        <p className="text-lg text-slate-300 mb-12 max-w-3xl">
          Apoello Ltd is a UK-based deep tech company focused on transforming
          molecular discovery through digitisation and automation. Building on
          research from leading academic groups, we combine chemical data,
          computational tools, and practical materials access in our flagship
          DiaDEM™ platform.
        </p>

        {/* Mission Section */}
        <div className="space-y-6 mb-12">
          <h2 className="text-2xl font-semibold text-orange-300 mb-4">
            Our Mission
          </h2>
          <p className="text-slate-300 max-w-3xl">
            We believe the future of molecular and materials discovery is
            digital. By bridging the gap between computation and experimentation,
            Apoello empowers researchers to move faster, reduce trial-and-error,
            and focus on solving real-world challenges across optoelectronics,
            sensors, energy, and healthcare.
          </p>
        </div>

        {/* Team Section */}
        <div className="space-y-6 mb-12">
          <h2 className="text-2xl font-semibold text-orange-300 mb-4">
            Our Team
          </h2>
          <p className="text-slate-300 max-w-3xl">
            Apoello was founded by a multidisciplinary team combining decades of expertise
            in computational chemistry, data science, and entrepreneurship. Our
            leadership team includes active researchers, technical innovators,
            and business strategists focused on real-world impact.
          </p>
        </div>

        {/* Subtle Contact Section */}
        <div className="mt-16 border-t border-slate-700 pt-8">
          <h2 className="text-xl font-semibold text-slate-300 mb-4">
            Interested in working with us?
          </h2>
          <p className="text-slate-400 mb-6 max-w-2xl">
            Whether you're seeking collaboration, partnerships, or simply want to
            learn more about Apoello, reach out using the form below.
          </p>
          <ContactForm3 />
        </div>
      </div>
    </section>

          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
